// Tab keys double as Mixpanel page names, so they keep their original spelling.
export const Nav = {
  KPI_MAPPING: 'KPI Mapping',
  CROSS_CHANNEL_FUNNEL: 'Cross Channel Funnels'
} as const;
export type NavType = (typeof Nav)[keyof typeof Nav];

export const NAV_LABELS: Record<NavType, string> = {
  [Nav.KPI_MAPPING]: 'KPI Mapping',
  [Nav.CROSS_CHANNEL_FUNNEL]: 'Cross-Channel Funnels'
};
